module.exports = __webpack_public_path__ + "img/upload-documents.32ee0c95.svg";